import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '@/shared/components/Button';

export const PwaUpdateProvider = () => {
  const [dismissed, setDismissed] = useState(false);
  const { t } = useTranslation('app');

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Service worker registration failed', error);
    },
  });

  if (!needRefresh || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-sm bg-surface-raised p-4 shadow-lg ring-1 ring-ink-subtle/30">
      <div className="text-sm">
        <p className="font-medium text-ink">{t('pwa.title')}</p>
        <p className="text-ink-muted">{t('pwa.description')}</p>
      </div>
      <Button
        size="sm"
        onClick={() => {
          void updateServiceWorker(true);
        }}
      >
        {t('pwa.update')}
      </Button>
      <Button
        size="sm"
        variant="ghost"
        color="neutral"
        onClick={() => {
          setDismissed(true);
        }}
      >
        {t('pwa.dismiss')}
      </Button>
    </div>
  );
};
